import { define } from './utils';
function customElement(name) {
    return function (targetClass) {
        define(name, targetClass);
        return targetClass;
    };
}
export { customElement };
